import Product from '@src/quince-site-common/src/domains/Product'
import Bundle, { PRODUCT_TYPES } from '@src/quince-site-common/src/domains/Product/BundleProduct'
import { GOLD_BAR_SUBCLASS } from '@src/quince-site-common/src/hooks/cart/constants/goldBar.constants'

export const getIsGoldBarProduct = (product: Product | undefined | Bundle) => {
  if (!product) return false
  const isBundle = product.type === PRODUCT_TYPES.BUNDLE
  if (isBundle) return false
  if (!product.classification?.subClass) return false
  return product.classification.subClass.id === GOLD_BAR_SUBCLASS
}

const GIFT_CARD_INTERNAL_IDS = ['44']

export const getIsGiftCard = (id?: number | string) => {
  if (!id) return false
  return GIFT_CARD_INTERNAL_IDS.includes(id.toString())
}
// Valentine's day Phase 1 Start Date in 2025 (January 28, 12:01 AM PST)
const HOLIDAY_CUTOFF_START = 1738051260000
// Valentine's day Phase 1 End Date in 2024 (February 4, 6:00 PM PST)
const HOLIDAY_CUTOFF_END = 1738720800000
export const isCurrentDateInHolidayCutoff = () => {
  const currentTime = Date.now()
  return currentTime >= HOLIDAY_CUTOFF_START && currentTime <= HOLIDAY_CUTOFF_END
}
